<template>
  <v-card id="obligations" height="100%" tile>
    <v-card-title>
      <v-toolbar flat class="obligations__toolbar">
        <v-app-bar-nav-icon @click.prevent="goBack()">
          <v-icon>chevron_left</v-icon>
        </v-app-bar-nav-icon>
        <v-toolbar-title class="obligations__toolbar-title">
          <v-row align="center">
            <v-col :class="['col', visibleObservations ? 'col-4' : 'col-8']">
              <!-- De quien son las obligaciones (contexto chico), el nombre
                   como titulo, y sus datos como pares dato/valor. -->
              <div class="obligations__context">
                {{ heading || resx.labels.obligations }}
              </div>
              <h1 class="obligations__name">{{ name }}</h1>
              <dl v-if="details && details.length" class="obligations__details">
                <div
                  v-for="detail in details"
                  :key="detail.label"
                  class="obligations__detail"
                >
                  <dt>{{ detail.label }}</dt>
                  <dd>{{ detail.value }}</dd>
                </div>
              </dl>
            </v-col>
            <v-col v-if="visibleObservations" class="col col-4">
              <div class="obligations__context">Observaciones</div>
              <div class="obligations__observations">{{ visibleObservations }}</div>
            </v-col>
            <v-col class="col col-4">
              <v-text-field
                append-icon="search"
                :label="resx.labels.search"
                single-line
                hide-details
                v-model="filters.search"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-toolbar-title>
      </v-toolbar>
    </v-card-title>
    <!-- En la pantalla de la contratista las notas van en la misma fila que
         los botones a Personal y Vehiculos; en la de un vehiculo o un
         empleado las pone el slot "notes". -->
    <contractor-sections v-if="currentSection" :current="currentSection">
      <notes-panel
        v-if="isSystemUser && notesScope && contractorId"
        :contractor-id="contractorId"
        :scope="notesScope"
        :value="notes"
        :size="notesSize"
      >
      </notes-panel>
    </contractor-sections>
    <slot v-else name="notes"></slot>
    <v-card-text>
      <v-row>
        <v-dialog
          max-width="800"
          :value="dateDialog"
          persistent
          :fullscreen="$vuetify.breakpoint.smAndDown"
          @keydown.esc="dateDialog = null"
        >
          <v-card v-if="dateDialog">
            <v-container grid-list-xl>
              <v-row row wrap>
                <v-col cols="12">
                  <datepicker-component
                    :value="dateDialog.value"
                    :data-vv-as="resx.labels.dueDate"
                    :data-vv-name="resx.labels.dueDate"
                    v-validate="'required'"
                    @input="
                      onDateDialogSave(
                        dateDialog.item,
                        $event,
                        dateDialog.newStatus
                      )
                    "
                    :label="resx.labels.dueDate"
                    :max="dateDialog.max"
                    :min="dateDialog.min"
                    :name="resx.labels.dueDate"
                  >
                  </datepicker-component>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dateDialog = null">{{ resx.labels.cancel }}</v-btn>
              <v-btn
                color="primary"
                @click="
                  onDateDialogSave(
                    dateDialog.item,
                    dateDialog.value,
                    dateDialog.newStatus
                  )
                "
                v-if="dateDialog.value"
                >{{ resx.labels.ok }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row>
        <edit-obligation
          v-model="openDialog"
          @close="onClose"
          @save="onSave"
          :adhoc="adhoc"
        ></edit-obligation>
      </v-row>
      <v-row>
        <v-card-text class="table-container fixed-header">
          <v-data-table
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="obligations"
            :no-data-text="resx.messages.noObligationsAvailable"
            :no-results-text="resx.messages.noObligationsFound"
            fixed-header
            height="auto"
            :search="filters.search"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
          >
            <template v-slot:item="{ item }">
              <tr
                :class="{
                  'disable-row':
                    item.status ==
                    $store.state.constants.OBLIGATIONS.STATUS.EXCLUDED
                }"
              >
                <td class="justify-center align-center px-8">
                  <v-icon
                    color="success"
                    v-if="
                      item.status &&
                        item.status ==
                          $store.state.constants.OBLIGATIONS.STATUS.DELIVERED
                    "
                    >check_circle</v-icon
                  >
                  <v-icon color="error" v-else>error</v-icon>
                </td>
                <td class="word-wrap">
                  <!-- Las etiquetas van a la derecha del nombre y bajan de
                       linea cuando no entran: es un contenedor en linea que
                       envuelve, no una columna aparte. -->
                  <span class="obligation-name">{{ item.name }}</span>
                  <v-chip
                    v-for="tag in tagsOf(item)"
                    :key="tag._id"
                    x-small
                    label
                    class="obligation-tag ml-2"
                    :color="tagBackground(tag)"
                    :text-color="textColorFor(tagBackground(tag))"
                  >{{ tag.name }}</v-chip>
                  <span
                    v-if="uncoveredOf(item)"
                    class="obligation-payroll-missing error--text ml-2"
                  >{{ uncoveredOf(item) }} sin incluir en la nómina</span>
                </td>
                <td class="comments-column word-wrap">
                  <comments-component
                    v-model="item.comments"
                    :text-ellipsis="false"
                    @input="onSaveComment(item, $event)"
                  />
                </td>
                <td class="hidden-xs-only word-wrap">
                  {{ resx.labels[item.dueDateType] }}
                </td>
                <td
                  class="hidden-xs-only word-wrap"
                  :class="lookupStatusClass(item)"
                >
                  {{ resx.labels[item.status + "_status"] }}
                </td>
                <td class="hidden-xs-only word-wrap">
                  {{ formatDate(item.dueDate) }}
                </td>
                <td>
                  <div class="d-flex align-center justify-center">
                  <!-- Solo con una etiqueta de nomina: quienes figuran. Sin
                       cargar o vencida se abre igual, de solo lectura. -->
                  <v-tooltip v-if="payrollScopeOf(item)" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon @click="payrollDialogItem = item">
                        <v-icon :color="payrollLockOf(item) ? 'grey' : 'primary'">groups</v-icon>
                      </v-btn>
                    </template>
                    <span>Nómina</span>
                  </v-tooltip>
                  <!-- Sin nomina se guarda el lugar: asi los iconos de cada
                       tipo quedan alineados entre filas. -->
                  <div v-else-if="contractor" class="obligation-action-spacer"></div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon @click="openFiles(item)">
                        <v-icon :color="hasValidFile(item) ? 'primary' : 'grey'">attach_file</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ resx.labels.view_files }}</span>
                  </v-tooltip>
                  <v-menu bottom auto content-class="obligations-item-menu">
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon>
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item
                        v-if="
                          item.status !=
                            $store.state.constants.OBLIGATIONS.STATUS.DELIVERED
                        "
                        @click="
                          changeStatus(
                            item,
                            $store.state.constants.OBLIGATIONS.STATUS.DELIVERED
                          )
                        "
                      >
                        <v-list-item-action>
                          <v-icon color="success">check</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.delivered_status
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          item.status !=
                            $store.state.constants.OBLIGATIONS.STATUS.DELAYED
                        "
                        @click="
                          changeStatus(
                            item,
                            $store.state.constants.OBLIGATIONS.STATUS.DELAYED
                          )
                        "
                      >
                        <v-list-item-action>
                          <v-icon color="error">clear</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          item.dueDateType ==
                          $store.state.constants.OBLIGATIONS.DUEDATE_TYPES.ONCE
                            ? resx.labels.not_delivered_status
                            : resx.labels.delayed_status
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="changeStatus(item, null)">
                        <v-list-item-action>
                          <v-icon color="primary">calendar_today</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>
                          {{
                            item.dueDate ? "Cambiar Fecha" : "Agregar Fecha"
                          }}</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item
                        v-if="
                          item.status !=
                            $store.state.constants.OBLIGATIONS.STATUS.EXCLUDED
                        "
                        @click="exclude(item)"
                      >
                        <v-list-item-action>
                          <v-icon color="error">clear</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.excludeObligation
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-if="
                          item.status ==
                            $store.state.constants.OBLIGATIONS.STATUS.EXCLUDED
                        "
                        @click="include(item)"
                      >
                        <v-list-item-action>
                          <v-icon color="success">check</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.includeObligation
                        }}</v-list-item-title>
                      </v-list-item>
                      <!-- Etiquetas va despues de las acciones de estado a
                           proposito: esas son las de todos los dias. Editar y
                           Borrar (solo adhoc) van al final de todo. -->
                      <v-list-item @click="tagsDialogItem = item">
                        <v-list-item-action>
                          <v-icon color="primary">label</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.tags
                        }}</v-list-item-title>
                      </v-list-item>
                      <!-- Con archivos se entra por el clip. -->
                      <v-list-item v-if="!hasFiles(item)" @click="openFiles(item)">
                        <v-list-item-action>
                          <v-icon color="primary">upload_file</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{ resx.labels.upload_file }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="openDialog = { selectedItem: item }"
                        v-if="item.adhoc"
                      >
                        <v-list-item-action>
                          <v-icon color="primary">mode_edit</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.edit
                        }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="remove(item)" v-if="item.adhoc">
                        <v-list-item-action>
                          <v-icon color="error">delete</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>{{
                          resx.labels.delete
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-row>
      <obligation-tags-dialog
        v-if="tagsDialogItem"
        :obligation="tagsDialogItem"
        :contractor-company-id="$route.params.id"
        @saved="onTagsSaved"
        @close="tagsDialogItem = null"
      >
      </obligation-tags-dialog>
      <obligation-payroll-dialog
        v-if="payrollDialogItem"
        :obligation="payrollDialogItem"
        :contractor-company-id="$route.params.id"
        :contractor="contractor"
        :scope="payrollScopeOf(payrollDialogItem)"
        :lock-message="payrollLockOf(payrollDialogItem)"
        @saved="onPayrollSaved"
        @close="payrollDialogItem = null"
      >
      </obligation-payroll-dialog>
      <obligation-files-dialog
        v-if="filesDialogItem"
        :obligation="filesDialogItem"
        :contractor-company-id="$route.params.id"
        :initial-period="filesDialogPeriod"
        @changed="loadFileSummary"
        @close="filesDialogItem = null"
      >
      </obligation-files-dialog>

      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            @click="openDialog = {}"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import { sprintf } from "sprintf-js";
import _ from "lodash";
import moment from "moment";

import commentsComponent from "@/components/common/comments.vue";
import datepickerComponent from "@/components/common/datepicker.vue";
import editObligation from "@/components/views//obligations/edit-obligation.view.vue";
import notesPanel from "@/components/views/contractor-company/notes-panel.vue";
import contractorSections from "@/components/views/contractor-company/contractor-sections.component.vue";
import obligationTagsDialog from "@/components/views/contractor-company/obligations/obligation-tags-dialog.component.vue";
import obligationFilesDialog from "@/components/views/contractor-company/obligations/obligation-files-dialog.component.vue";
import obligationPayrollDialog from "@/components/views/contractor-company/obligations/obligation-payroll-dialog.component.vue";
import contractorCompanyService from "@/services/ContractorCompanyService";
import { fileKey, hasCurrentFile } from "@/utils/period";
import roles from "@/utils/roles";
import tagsService from "@/services/TagsService";
import { tagBackground, textColorFor } from "@/utils/tag-color";
import { payrollScope, uncoveredCount, payrollLockMessage } from "@/utils/payroll";

export default {
  name: "listObligations",
  async mounted() {
    this.loadTagCatalog();
    this.loadFileSummary();
    this.initObligations = this.obligations;
    this.obligations.forEach(i => {
      i.delivered =
        i.status == this.$store.state.constants.OBLIGATIONS.STATUS.DELIVERED;
      i.comments = i.comments ? i.comments : null;
    });
  },
  components: {
    obligationFilesDialog,
    obligationPayrollDialog,
    commentsComponent,
    datepickerComponent,
    editObligation,
    notesPanel,
    contractorSections,
    obligationTagsDialog
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      dateDialog: null,
      openDialog: null,
      tagsDialogItem: null,
      payrollDialogItem: null,
      // Catalogo de etiquetas para dibujar las pildoras: las obligaciones
      // guardan solo ids.
      tagCatalog: [],
      filesDialogItem: null,
      // Periodo con el que abre el modal de archivos (null = mes actual).
      filesDialogPeriod: null,
      // { [fileKey]: { count, lastPeriod } } de archivos vivos por obligacion,
      // cargado una vez: decide si el menu dice "Cargar archivo" o "Ver archivos".
      fileSummary: {},
      filters: {
        search: null
      },
      headers: [
        { sortable: false, align: "center", width: 48 },
        {
          text: resx.labels.name,
          value: "name",
          width: "30%"
        },
        {
          text: resx.labels.comments,
          value: "comments",
          class: "hidden-xs-only",
          sortable: false,
          width: "30%"
        },
        {
          text: resx.labels.dueDateType,
          value: "dueDateType",
          class: "hidden-xs-only",
          width: "10%"
        },
        {
          text: resx.labels.status,
          value: "status",
          class: "hidden-xs-only",
          width: "7%"
        },
        {
          text: resx.labels.dueDate,
          value: "dueDate",
          class: "hidden-xs-only",
          width: "13%"
        },
        {
          text: resx.labels.actions,
          value: "actions",
          sortable: false,
          width: 100
        }
      ],
      initObligations: [],
      selected: [],
      adhoc: { obligations: [this.type] }
    };
  },
  computed: {
    // Las notas son del personal del sistema.
    // Texto interno de la ficha: lo ven los mismos que ven los comentarios.
    visibleObservations() {
      return this.isSystemUser ? (this.observations || "").trim() : "";
    },
    isSystemUser() {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        this.$store.state.constants.roles.ALL_SYS_ROLES
      );
    },
    tagCatalogById() {
      return this.tagCatalog.reduce((byId, tag) => {
        byId[tag._id] = tag;
        return byId;
      }, {});
    }
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    // Calcula la proxima fecha de vencimiento de las obligaciones 'monthly' una vez que marcó que ya entrego una obligación vencida
    getDueDate(o, action = 1) {
      // action 1, get next dueDate, other value get previous dueDate
      const dueDate = moment(o.dueDate);
      const endOfMonth =
        action == 1
          ? dueDate.add(1, "month").endOf("month")
          : dueDate.subtract(1, "month").endOf("month");
      const nextDueDate = moment([
        endOfMonth.get("year"),
        endOfMonth.get("month"),
        o.dayOfMonth
      ]);
      return !nextDueDate.isValid() || nextDueDate.isAfter(endOfMonth)
        ? endOfMonth
        : nextDueDate;
    },
    formatDate(date) {
      return date
        ? moment(date).format(this.$store.state.constants.DATE_FORMAT)
        : "";
    },
    async remove(obligation) {
      await this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.obligations.toLowerCase()}`,
        content: sprintf(
          this.resx.messages.deleteObligationMessage,
          obligation.name
        )
      });
      this.$emit("delete", obligation);
    },
    // Abre open popup for edit obligations Adhoc
    edit(obligation) {
      this.openDialog = {
        selectedItem: obligation
      };
    },
    // Method for add Obligations Adhoc
    onClose() {
      this.openDialog = null;
    },
    // El backend ya persistio: aca solo se refleja en la fila para no recargar
    // toda la tabla por un etiquetado.
    onTagsSaved(tags) {
      if (this.tagsDialogItem) {
        this.$set(this.tagsDialogItem, "tags", tags);
      }
      // Una etiqueta creada mientras esta pantalla estaba abierta no esta en
      // el catalogo: se recarga para que su pildora aparezca con su color.
      this.loadTagCatalog();
    },
    // Nomina: solo en la pantalla de la contratista, que es la que pasa la
    // contratista con su personal y sus vehiculos.
    payrollScopeOf(item) {
      if (!this.contractor) return null;
      return payrollScope(
        item,
        this.tagCatalogById,
        this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION
      );
    },
    payrollLockOf(item) {
      return payrollLockMessage(item, this.$store.state.constants.OBLIGATIONS);
    },
    uncoveredOf(item) {
      if (this.payrollLockOf(item)) return 0;
      return uncoveredCount(item, this.contractor, this.payrollScopeOf(item));
    },
    onPayrollSaved(references) {
      if (this.payrollDialogItem) {
        this.$set(this.payrollDialogItem, "coveredReferences", references);
      }
    },
    async loadFileSummary() {
      try {
        this.fileSummary = await contractorCompanyService.obligationFilesSummary(this.$route.params.id);
      } catch (error) {
        // http.js ya publica el error; sin resumen el menu ofrece "Cargar
        // archivo" y el modal igual muestra lo que haya.
      }
    },
    hasFiles(item) {
      const entry = this.fileSummary[fileKey(item)];
      return !!entry && entry.count > 0;
    },
    // En color solo con un archivo del ciclo vigente: vencida no tiene ninguno.
    hasValidFile(item) {
      return !this.isExpired(item) && hasCurrentFile(this.fileSummary[fileKey(item)], item);
    },
    isExpired(item) {
      return !!this.payrollLockOf(item);
    },
    // Abre en el ultimo periodo con archivos; sin archivos, en el actual.
    openFiles(item) {
      this.filesDialogPeriod = this.hasFiles(item) ? this.fileSummary[fileKey(item)].lastPeriod : null;
      this.filesDialogItem = item;
    },
    async loadTagCatalog() {
      try {
        this.tagCatalog = await tagsService.list();
      } catch (error) {
        // http.js ya publica el error; sin catalogo las pildoras no se dibujan
        // y el resto de la pantalla sigue andando.
      }
    },
    tagBackground,
    textColorFor,
    // Las etiquetas de una obligacion llegan como ids o como objetos segun si
    // el backend populo; en los dos casos el nombre y el color salen del
    // catalogo. Una etiqueta borrada no se dibuja.
    tagsOf(item) {
      const byId = this.tagCatalogById;
      return (item.tags || [])
        .map(t => byId[typeof t === "string" ? t : (t && t._id)])
        .filter(Boolean);
    },
    // Method for add Obligations Adhoc
    async onSave(action) {
      this.$emit("save", action);
      this.onClose();
    },
    // Set status for obligations and change dueDate
    changeStatus(item, newStatus) {
      const OBLIGATIONS = this.$store.state.constants.OBLIGATIONS; // Shortcut for Obligations constants
      let value = null;
      if (item.dueDateType == OBLIGATIONS.DUEDATE_TYPES.MONTHLY) {
        value = this.getDueDate(
          item,
          newStatus == OBLIGATIONS.STATUS.DELAYED ? -1 : 1
        ).toISOString();
      }
      if (
        item.dueDateType == OBLIGATIONS.DUEDATE_TYPES.ONCE &&
        newStatus == OBLIGATIONS.STATUS.DELIVERED
      ) {
        const isDueDateValid =
          item.dueDate &&
          moment(item.dueDate).isValid() &&
          moment().isBefore(moment(item.dueDate), "day");
        item.dueDate = isDueDateValid ? item.dueDate : moment().toISOString();
        item.status = newStatus;
        this.$emit("save", { isNew: false, item });
      } else {
        this.dateDialog = {
          item,
          newStatus,
          max:
            newStatus == OBLIGATIONS.STATUS.DELAYED
              ? moment()
                  .subtract(1, "day")
                  .toISOString()
                  .substr(0, 10)
              : "",
          min:
            newStatus == OBLIGATIONS.STATUS.DELAYED
              ? ""
              : newStatus != null
              ? moment()
                  .toISOString()
                  .substr(0, 10)
              : "",
          value
        };
      }
    },
    // Handle for dateDialog save event
    onDateDialogSave(item, dateValue, newStatus) {
      item.dueDate = dateValue;
      if (
        item.dueDateType !==
        this.$store.state.constants.OBLIGATIONS.DUEDATE_TYPES.ONCE
      ) {
        item.status = moment(dateValue).isBefore(moment(), "day")
          ? this.$store.state.constants.OBLIGATIONS.STATUS.DELAYED
          : this.$store.state.constants.OBLIGATIONS.STATUS.DELIVERED;
      } else {
        item.status = newStatus !== null ? newStatus : item.status;
      }
      this.$emit("save", { isNew: false, item });
      this.dateDialog = null;
    },
    onSaveComment(item, commentValue) {
      item.comments = commentValue;
      this.$emit("save", { isNew: false, item });
    },
    lookupStatusClass(item) {
      const STATUS = this.$store.state.constants.OBLIGATIONS.STATUS;
      const mappings = {
        [STATUS.DELAYED]: "error--text",
        [STATUS.DELIVERED]: "success--text",
        [STATUS.MISSING_DATE]: "error--text",
        [STATUS.APPROVAL_PENDING]: "warning--text",
        [STATUS.NOT_DELIVERED]: "error--text"
      };
      return mappings[item.status] ? mappings[item.status] : "primary--text";
    },
    goBack() {
      this.$router.back();
    },
    exclude(item) {
      item.status = this.$store.state.constants.OBLIGATIONS.STATUS.EXCLUDED;
      delete item.dueDate;
      this.$emit("save", { isNew: false, item });
    },
    include(item) {
      item.status = this.$store.state.constants.OBLIGATIONS.STATUS.MISSING_DATE;
      delete item.dueDate;
      this.$emit("save", { isNew: false, item });
    },
    nameFilter(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.filters.search) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.filters.search.toLowerCase());
    }
  },
  props: [
    "obligations",
    "name",
    "type",
    // Los pasa contractor-obligations.view.vue para su panel de notas por
    // defecto; las pantallas por vehiculo y por empleado lo reemplazan con
    // el slot "notes" (notas y comentarios propios) y no los usan.
    "contractorId",
    "notesScope",
    "observations",
    "notes",
    "notesSize",
    // Texto chico sobre el nombre: de quien son las obligaciones
    // ("Obligaciones del vehículo"). Sin valor, dice "Obligaciones".
    "heading",
    // Datos bajo el nombre, como pares [{ label, value }] (patente, CUIT, tipo).
    "details",
    // Solo la pantalla de obligaciones de la contratista lo pasa
    // ("obligations"): muestra los botones a Personal y Vehiculos. Las de un
    // vehiculo o un empleado puntual no los llevan.
    "currentSection",
    // La contratista con su personal y sus vehiculos, para las obligaciones
    // de nomina. Solo la pasa la pantalla de obligaciones de la contratista.
    "contractor"
  ],
  watch: {
    obligations(val) {
      if (this.initObligations.length == 0 && val && val.length > 0) {
        this.initObligations = _.clone(val);
      }
    }
  }
};
</script>

<style lang="scss">
// El encabezado crece con su contenido: la barra de Vuetify fija 64px y
// recortaria el nombre y los datos.
#obligations .obligations__toolbar,
#obligations .obligations__toolbar .v-toolbar__content {
  height: auto !important;
}

#obligations .obligations__toolbar .v-toolbar__content {
  padding-top: 8px;
  padding-bottom: 8px;
}

#obligations .obligations__toolbar-title {
  white-space: normal;
  overflow: visible;
}

#obligations .obligations__context {
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.4;
}

#obligations .obligations__name {
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: rgba(0, 0, 0, 0.87);
  margin: 2px 0 0;
}

#obligations .obligation-action-spacer {
  width: 36px;
  flex: none;
}

#obligations .obligations__observations {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
  white-space: pre-line;
  overflow-wrap: anywhere;
}

// Pares dato/valor sueltos, separados por espacio, no por separadores.
#obligations .obligations__details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 10px 0 0;
}

#obligations .obligations__detail {
  display: flex;
  align-items: baseline;
  gap: 6px;
  line-height: 1.3;

  dt {
    font-size: 0.8125rem;
    color: rgba(0, 0, 0, 0.6);
  }

  dd {
    font-size: 0.9375rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
  }
}


// Cuadrado redondeado: mas radio que el `label` de Vuetify (4px) pero sin
// llegar a la pildora totalmente redonda.
.obligation-tag.v-chip {
  vertical-align: middle;
  border-radius: 8px;
  // x-small trae 10px; un poco mas grande y en negrita para que se lea de un
  // vistazo al lado del nombre.
  font-size: 12px;
  font-weight: 700;
  height: 22px;
}
// El nombre y las pildoras se centran entre si en la misma linea.
.obligation-name {
  vertical-align: middle;
}
.obligation-payroll-missing {
  vertical-align: middle;
  font-size: 12px;
  font-weight: 500;
}
.icon {
  cursor: pointer;
}
table.v-table thead th:first-child {
  padding: 0;
}

#obligations {
  .comments-column {
    max-width: 500px;
  }
}
.obligations-item-menu {
  max-height: initial !important;
}

tr.disable-row {
  opacity: 0.3;
}

.v-card__text .table-container .fixed-header .col {
  margin-bottom: 50px;
}

.v-toolbar__title {
  width: 100%;
}
</style>
